import React from "react";
import styled, { withTheme } from "styled-components";
import NutritionItem from "../NutritionItem/NutritionItem";
import { useTranslation } from "react-i18next";
import { isJapanese } from "../../../i18n/helpers";

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const CaloriesItem = styled(NutritionItem)`
  margin-bottom: 20px;
`;

const Item = styled.p`
  margin-bottom: 10px;
`;

const Title = styled.label`
  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.theme?.nero};
  margin-bottom: 14px;
`;

const GoalIcon = styled.i`
  color: ${(props) => props.color || "#000000"};
  margin-right: 5px;
  transform: ${(props) => props?.isRtl && "scaleX(-1)"};
`;

const GoalLabel = styled.span`
  color: ${(props) => props.color || "#000000"};
  font-weight: bold;
`;

const DailyTargets = (props) => {
  const { goalTitle, goalsList, calories, isRtl } = props;

  const { t } = useTranslation();

  return (
    <ComponentWrapper className="goal-card-body" data-testid="daily-goals">
      <Title>{goalTitle}</Title>
      {calories && (
        <CaloriesItem
          value={calories?.calories}
          backgroundColor={props.theme?.lightShadeMagenta}
          titleColor={props.theme?.darkPurple}
        />
      )}
      {goalsList.map(function (item, index) {
        return (
          <Item key={index}>
            <GoalIcon
              data-testid="goal-item"
              color={item.goalColor}
              className="fas fa-flag-checkered"
              isRtl={isRtl}
            />
            {`${item.goalValue} ${t("appText.from")} `}
            <GoalLabel data-testid="goal-label" color={item.goalColor}>
              {item.goalLabel}
            </GoalLabel>
          </Item>
        );
      })}
    </ComponentWrapper>
  );
};
export default withTheme(DailyTargets);
